<template>
    <div class="bg-white px2-pc px1-mobile pb-1">
        <div layout="row" layout-align="start center" class="title grey--text text-uppercase font-weight-medium mb2-pc mb1-mobile mt3-pc mt2-mobile">{{$t('params.config')}}</div>

        <v-form class="mt5-pc mt3-mobile" layout="column" layout-align="center center" ref="form" @submit.prevent="save">
            <div class="width-95-mobile">
                <div class="font-weight-bold mb-2 mt-3">{{$t('params.national_secr')}}</div>
                <v-text-field v-model="params.national_secretariat_mail" class="field-width"></v-text-field>
                <div class="font-weight-bold mb-2 mt-3">{{$t('params.ministry_secr')}}</div>
                <v-text-field v-model="params.ministry_secretariat_mail" class="field-width"></v-text-field>

                <div class="font-weight-bold mb-2 mt-3">{{$t('params.men_logo')}}</div>

                <avatar v-if="imageUrl" size="50" :image="imageUrl"></avatar>
                <avatar v-else-if="params.men_logo_id && getImageData(params.men_logo_id)" size="50" :image="getImageData(params.men_logo_id)"></avatar>

                <v-text-field @click="pickFile('image')" @keyup.enter="pickFile('image')" v-model="imageName" :placeholder="$t('params.logo_add')" prepend-icon="mdi-image-multiple"></v-text-field>
                <input type="file" style="display: none" ref="image" accept="image/*" @change="onFilePicked">

                <div class="font-weight-bold mb-2 mt-3">{{$t('params.doc')}}</div>
                <div layout="row" layout-align="start center">
                    <v-text-field @click="pickFile('doc')" @keyup.enter="pickFile('doc')" v-model="docName" :placeholder="$t('ged.add_doc')" prepend-icon="mdi-file"></v-text-field>
                    <input type="file" style="display: none" ref="doc" @change="onDocPicked" accept="application/pdf">
                    <v-btn flat outline color="secondary" :disabled="!params.documentation_id" :title="$t('ged.download')" @click="download(params.documentation_id)">
                        <v-icon>mdi-download</v-icon>
                        {{$t('ged.download')}}
                    </v-btn>
                </div>
            </div>
            <div layout="row" layout-align="end center" class="field-width width-95-mobile">
                <v-btn depressed color="secondary" @click="save" style="text-transform: none">{{$t('_.save')}}</v-btn>
            </div>
        </v-form>
    </div>
</template>

<script>
    import Params from '@/api/params'
    import FormDataMixin from '~/mixins/formdata'
    import ImageMixin from '@/mixins/image'
    import Avatar from '@/components/shared/Avatar.vue'
    import axios from 'axios'

    const KEYS = ['national_secretariat_mail', 'ministry_secretariat_mail', 'men_logo_id', 'documentation_id'];

    export default {
        components: {Avatar},
        mixins: [FormDataMixin, ImageMixin],
        data () {
            return {
                params: {},
                imgs: {},
                imgsLoad: {},
                imageData: null,
                imageName: null,
                imageUrl: null,
                docData: null,
                docName: null,
                files: {}
            }
        },
        mounted () {
            this.fetch();
        },
        methods: {
            fetch () {
                Params.getList('params').then(res => {
                    this.params = {};

                    for (let i = 0; i < res.data.length; ++i) {
                        const p = res.data[i];

                        this.params[p.name] = p.value;

                        if(p.file){
                            this.files[p.value] = p.file
                        }
                    }

                    for (let i = 0; i < KEYS.length; ++i) {
                        if (!this.params.hasOwnProperty(KEYS[i])) {
                            this.params[KEYS[i]] = '';
                        }
                    }

                    if(this.params.men_logo_id){
                        this.getImage('/assets/logoMen/' + this.params.men_logo_id, this.params.men_logo_id);
                    }
                })
            },

            save () {
                // Convert the data to FormData for proper file upload
                let formData = new FormData();
                this._convertObjectToFormData(formData, {params: this.params});

                if (this.imageData) {
                    formData.append("men_logo_id", this.imageData, this.imageName);
                }

                if (this.docData) {
                    formData.append("documentation_id", this.docData, this.docName);
                }

                Params.multi('params', formData).then(() => {
                    this.$snotify.success(this.$t('params.params_saved'))
                    this.fetch()
                })
            },

            pickFile(f) {
                this.$refs[f].click();
            },
            onFilePicked(e) {
                const files = e.target.files;
                if (files[0] !== undefined) {
                    this.imageData = files[0];
                    this.imageName = files[0].name;
                    this.imageUrl = URL.createObjectURL(this.imageData);
                }
            },
            onDocPicked(e) {
                const files = e.target.files;
                if (files[0] !== undefined) {
                    this.docData = files[0];
                    this.docName = files[0].name;
                }
            },

            download (id) {
                let a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                let name = "documentation_" + id + ".pdf"

                if(this.files[id]){
                    name = this.files[id].name
                }

                axios.get('/assets/documentation/' + id, {responseType: 'blob',}).then(res => {
                    let blob = new Blob([res.data], {type: "octet/stream"});

                    if (window.navigator && window.navigator.msSaveOrOpenBlob){
                        window.navigator.msSaveBlob(blob, name);
                    }
                    else
                    {
                        let url = window.URL.createObjectURL(blob);
                        a.href = url;
                        a.download = name;
                        a.click();
                        window.URL.revokeObjectURL(url);
                    }
                });
            }
        }
    }
</script>